export default __webpack_public_path__ + "static/media/photo-1-light.39126066.jpg";